import CreateEditCampaignContainer from '~/features/campaigns/components/createEditContainer'

function CreateCampaignPage() {
  return <CreateEditCampaignContainer />
}

export default CreateCampaignPage
